import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

import serverRoutes from '@app/utils/server-routes';

const baseUrl = process.env.REACT_APP_BACKEND_URL;

export const kerberosAuthApi = createApi({
  reducerPath: 'kerberosAuthApi',
  tagTypes: [],
  baseQuery: fetchBaseQuery({
    baseUrl,
  }),
  endpoints: (build) => ({
    getKerberosAuthApiStatus: build.query<
      {
        sso_krb_enabled: boolean;
      },
      void
    >({
      query: () => ({
        url: serverRoutes.sso_kerberos_auth,
      }),
    }),
  }),
});

export const { useGetKerberosAuthApiStatusQuery } = kerberosAuthApi;
